
















































import { MoveDirection } from '~/models/search/map/types'
import { defineComponent } from '~/utils/nuxt3-migration'

export default defineComponent({
  props: {
    title: { type: String, default: '' },
    subtitle: { type: String, default: '' },
    disabled: { type: Boolean, default: false }
  },
  data() {
    return {
      headerHeight: process.client
        ? document.querySelector('#header-container')?.clientHeight || 50
        : 50,
      headerDrawerHeight: 0,
      drawerHeight: 0,
      screenHeight: 0,
      drawerPaddingInPixels: 8,
      isDrawerFullScreenExpanded: false,
      scrollDirection: null,
      top: null,
      drawerContainer: null,
      touchStartEvent: null,
      isDrawerOpen: false,
      scrollPosition: 0,
      touchMoveDirection: '',
      drawerAnimation: false,
      allowToClose: false,
      drawerOverflow: 'initial',
      disabledVisualViewportChange: false
    }
  },
  computed: {
    drawerTranform(): string {
      if (
        this.isDrawerOpen &&
        this.touchMoveDirection === MoveDirection.DOWN &&
        this.allowToClose
      ) {
        return `translate(0, ${this.scrollPosition}px)`
      } else if (this.isDrawerOpen) {
        return `translate(0, 0)`
      } else {
        return `translate(0, ${this.scrollPosition || this.top}px)`
      }
    }
  },
  beforeUpdate() {
    if (window.scrollY) {
      window.scroll(0, 0)
    }
  },
  mounted() {
    if (window?.visualViewport) {
      window.visualViewport.addEventListener('resize', this.handleViewport, {
        capture: true,
        passive: true
      })
    }
    this.screenHeight = window?.visualViewport
      ? window.visualViewport.height
      : window.screen.height
    this.headerDrawerHeight = this.$refs.header.clientHeight
    this.drawerHeight =
      this.screenHeight - this.drawerPaddingInPixels - this.headerDrawerHeight
    this.top = this.screenHeight - this.headerDrawerHeight - this.headerHeight
    this.drawerContainer = this.$refs.drawerContainer
  },
  activated() {
    this.disabledVisualViewportChange = false
    this.handleViewport()
  },
  deactivated() {
    this.disabledVisualViewportChange = true
  },
  destroyed() {
    if (window?.visualViewport) {
      window.visualViewport.removeEventListener('resize', this.handleViewport)
    }
  },
  methods: {
    clickOnHeader() {
      if (this.isDrawerOpen) {
        this.collapseDrawer()
      } else {
        this.expandDrawer()
      }
    },
    onTouchStart(e: TouchEvent) {
      this.touchStartEvent = e.changedTouches[0].clientY
    },
    onTouchMove(e: TouchEvent) {
      const te = e.changedTouches[0].clientY
      if (
        this.isDrawerOpen &&
        this.$refs?.drawer?.scrollTop === 0 &&
        this.touchMoveDirection === MoveDirection.DOWN
      ) {
        if (e.cancelable) {
          e.preventDefault()
        }
      }
      const topTranslate = this.top + (te - this.touchStartEvent)
      if (!this.isDrawerOpen) {
        if (topTranslate > this.top) {
          this.scrollPosition = this.top
        } else {
          this.scrollPosition = topTranslate
        }
      } else {
        this.scrollPosition = te - this.touchStartEvent
        this.drawerAnimation = false
      }

      if (this.touchStartEvent > te) {
        this.touchMoveDirection = MoveDirection.UP
      } else {
        this.touchMoveDirection = MoveDirection.DOWN
      }

      if (
        this.$refs.drawer?.scrollTop === 0 &&
        this.touchMoveDirection === MoveDirection.DOWN
      ) {
        this.allowToClose = true
      } else {
        this.allowToClose = false
      }
    },

    expandDrawer(pixelsToScroll: number = null) {
      this.drawerAnimation = true
      this.isDrawerOpen = true
      this.drawerOverflow = 'scroll'
      this.onDrawerChange(true)
      this.scrollPosition = 0
      if (pixelsToScroll > -1) {
        this.$nextTick(() => this.scrollTo(pixelsToScroll))
      }
    },
    collapseDrawer() {
      this.scrollTo()
      this.drawerAnimation = true
      this.onDrawerChange(false)
      this.scrollPosition = 0
      this.isDrawerOpen = false
      this.drawerOverflow = 'initial'
      this.touchMoveDirection = null
      setTimeout(() => (this.drawerAnimation = false), 300)
    },
    onTouchEnd() {
      const drawerContainerPosition =
        this.drawerContainer.scrollTop + this.headerDrawerHeight
      setTimeout(
        () =>
          (this.drawerOverflow = `${
            this.getDrawerTopPosition() >= this.headerHeight
              ? 'scroll'
              : 'initial'
          }`),
        300
      )
      if (
        drawerContainerPosition >= this.headerHeight &&
        !this.isDrawerOpen &&
        !this.isScrolling
      ) {
        this.expandDrawer()
      } else if (
        this.isDrawerOpen &&
        this.$refs.drawer?.scrollTop <= 0 &&
        this.touchMoveDirection === MoveDirection.DOWN
      ) {
        this.collapseDrawer()
      }
    },
    getDrawerTopPosition(): number {
      if (this.$refs.drawer) {
        return this.$refs.drawer.getBoundingClientRect().top
      }
    },
    handleViewport() {
      if (window?.visualViewport && !this.disabledVisualViewportChange) {
        this.screenHeight = window.visualViewport.height
        this.top =
          this.screenHeight - this.headerDrawerHeight - this.headerHeight
      }
    },
    onDrawerChange(status: Boolean) {
      this.$emit('change', status)
      this.isDrawerFullScreenExpanded = status
    },
    scrollTo(pixels: number = 0) {
      if (this.$refs.drawer?.scrollTo) {
        this.$refs.drawer.scrollTo(0, pixels)
      }
    }
  }
})
